var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.886 13.339L16 10.423L13.114 13.339H18.886ZM18.109 19.408L22.546 14.419H20.644L18.109 19.408ZM20.809 13.339H22.684L19.921 9.886L20.809 13.339ZM27.04 4H4.96C4.429 4 4 4.429 4 4.96V27.04C4 27.571 4.429 28 4.96 28H27.04C27.571 28 28 27.571 28 27.04V4.96C28 4.429 27.571 4 27.04 4ZM24.601 13.966L16.114 23.509C16.084 23.542 16.042 23.56 16 23.56C15.958 23.56 15.916 23.542 15.886 23.509L7.399 13.966C7.3749 13.939 7.3611 13.9043 7.36 13.8681C7.3589 13.8319 7.37059 13.7965 7.393 13.768L11.608 8.5C11.638 8.464 11.68 8.443 11.728 8.443H20.266C20.314 8.443 20.356 8.464 20.386 8.5L24.601 13.768C24.6257 13.7951 24.6393 13.8304 24.6393 13.867C24.6393 13.9036 24.6257 13.9389 24.601 13.966ZM12.568 14.419L16 21.175L19.432 14.419H12.568ZM12.079 9.886L9.316 13.339H11.191L12.079 9.886ZM9.454 14.419L13.891 19.408L11.356 14.419H9.454ZM13.249 9.673L12.556 12.367L15.22 9.673H13.249ZM18.751 9.673H16.78L19.444 12.367L18.751 9.673Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.c8f33b6b5d271a96fc69a81c91162f3d.svg";
export { ForwardRef as ReactComponent };